export default __webpack_public_path__ + "static/media/mobile.6523ec44.svg";